import { PopupModal } from "../../../../../components/Modal";

export const INPUT_CLASS =
  "w-full px-3 py-2 text-sm rounded-md border border-border-secondary bg-surface-primary text-content-primary focus:outline-none focus:ring-1 focus:ring-brand-primary focus:border-brand-primary placeholder:text-content-tertiary";

export const FIELD_LABEL_CLASS =
  "block text-xs font-medium text-gray-500 mb-1";

/** Shared v1 modal scaffold: title, body, Cancel + primary submit. */
export function ActionModal({
  title,
  children,
  submitLabel,
  onSubmit,
  onClose,
  pending = false,
  disabled = false,
  danger = false,
  secondarySubmit,
  wide = false,
}: {
  title: string;
  children: React.ReactNode;
  submitLabel: string;
  onSubmit: () => void;
  onClose: () => void;
  pending?: boolean;
  disabled?: boolean;
  danger?: boolean;
  /** An optional second submit (e.g. `Log fix` beside `Log fix & verify`). */
  secondarySubmit?: { label: string; onSubmit: () => void; disabled?: boolean };
  wide?: boolean;
}) {
  return (
    <PopupModal
      onClose={pending ? undefined : onClose}
      contentClassName={`mx-auto w-full ${wide ? "max-w-2xl" : "max-w-lg"} max-h-[90dvh] overflow-y-auto`}
    >
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-content-primary">{title}</h3>
        <button
          onClick={onClose}
          disabled={pending}
          className="text-content-tertiary hover:text-content-primary transition-colors text-xl leading-none"
        >
          ×
        </button>
      </div>
      <div className="flex flex-col gap-4">{children}</div>
      <div className="flex justify-end gap-2 pt-2">
        <button
          onClick={onClose}
          disabled={pending}
          className="px-4 py-2 text-sm font-medium text-content-secondary bg-surface-secondary rounded-md border border-border-secondary hover:bg-surface-hover transition-colors disabled:opacity-50"
        >
          Cancel
        </button>
        {secondarySubmit && (
          <button
            onClick={secondarySubmit.onSubmit}
            disabled={pending || disabled || secondarySubmit.disabled}
            className="px-4 py-2 text-sm font-medium rounded-md border border-brand-primary text-brand-primary hover:bg-[#E7F1F3] transition-colors disabled:opacity-50"
          >
            {secondarySubmit.label}
          </button>
        )}
        <button
          onClick={onSubmit}
          disabled={pending || disabled}
          className={`px-4 py-2 text-sm font-medium text-white rounded-md transition-colors disabled:opacity-50 ${
            danger
              ? "bg-red-600 hover:bg-red-700"
              : "bg-brand-primary hover:bg-brand-primary-hover"
          }`}
        >
          {pending ? "Working…" : submitLabel}
        </button>
      </div>
    </PopupModal>
  );
}
